import { render, staticRenderFns } from "./Liquidity.vue?vue&type=template&id=49df8eae&scoped=true"
import script from "./Liquidity.vue?vue&type=script&lang=js"
export * from "./Liquidity.vue?vue&type=script&lang=js"
import style0 from "./Liquidity.vue?vue&type=style&index=0&id=49df8eae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49df8eae",
  null
  
)

export default component.exports